import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import { TableProvider } from './context/TableContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <TableProvider>
        <App />
      </TableProvider>
  </React.StrictMode>
);